import { createUseStyles } from 'react-jss'
import { darkGrey, lightGrey } from '../../../../styles/const/colors'
import { textEllipsis } from '../../../../styles/mixins/text'

const useStyles = createUseStyles({
  postPreview: {
    width: '100%',
    maxWidth: 243,
    border: `1px solid ${lightGrey}`,
    backgroundColor: '#fff',
    margin: '0 auto',
    fontFamily: 'Roboto, sans-serif',
    position: 'relative',
    marginBottom: 24
  },
  postHeader: {
    padding: 10,
    display: 'flex',
    alignItems: 'center'
  },
  postProfilePhotoContainer: {
    minWidth: 32,
    maxWidth: 32,
    minHeight: 32,
    maxHeight: 32,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    overflow: 'hidden',
    marginRight: 8
  },
  postProfilePhotoImage: {
    width: '100%',
    maxWidth: '100%'
  },
  postProfileName: {
    fontSize: 11,
    color: darkGrey,
    fontWeight: 700,
    ...textEllipsis()
  },
  postActionsContainer: {
    padding: '8px 10px 0px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    columnGap: 8
  },
  postMainActionsIcons: {
    display: 'flex',
    alignItems: 'center',
    columnGap: 6
  },
  postActionIcon: {
    width: 13
  },
  postFooter: {
    padding: '7px 10px 10px',
    position: 'relative'
  },
  postFooterProfileName: {
    display: 'inline-block',
    maxWidth: '100%',
    verticalAlign: 'top',
    marginRight: 4,
    ...textEllipsis()
  },
  postFooterText: {
    fontSize: 10
  },
  postMediaItemsContainer: {
    width: '100%',
    maxHeight: 400,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden'
  },
  postMediaItem: {
    maxWidth: '100%',
    maxHeight: '100%',
    margin: '0 auto',
    display: 'block'
  },
  postMediaCarouselContainer: {
    position: 'relative'
  },
  postMediaCarouselDotsContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    columnGap: 2.5,
    position: 'absolute',
    bottom: -16
  },
  postMediaCarouselDot: {
    width: 4,
    height: 4,
    background: '#D9D9D9',
    borderRadius: '50%',
    '&.active': {
      background: '#0095F6'
    }
  }
})

export default useStyles
